// PATHS
import axios from "axios";

const SEARCH_CONTRACTOR = "/network/contractor/search";
const INSERT_DOCUMENTS = "/network/documents/contractor";
const UPDATE_DASHBOARD = "/network/contractorDashboard/create";
const GET_DASHBOARD_DATA = "/network/contractorDashboard/find";
const SAVE_DASHBOARD_FILE = "/network/documentHistory/createDocumentDashboard";
const GET_HISTORY_DASHBOARD = "/network/documentHistory/findDashboardByYear";
const GET_CONTRACTOR_ROYALTIES = "/network/panelConfiguration/find";
const UPDATE_CONTRACTOR_ROYALTIES = "/network/panelConfiguration/create";
const GET_DMS_LIST = "/network/ms/objectsDms";
const SAVE_CONTRACTOR_ASSOCIATIONS = "/network/contractor/saveAssociation";
const GET_CONTRACTOR_BY_ID = "/network/contractor/";

const searchContractor: any = async (req: any) => {
	const response = await axios.post(SEARCH_CONTRACTOR, req);
	return response.data;
};

const insertDocumentsContractor: any = async (req: any) => {
	const response = await axios.post(INSERT_DOCUMENTS, req);
	return response.data;
};

const updateDashboard: any = async (req: any) => {
	const response = await axios.post(UPDATE_DASHBOARD, req);
	return response.data;
};

const getDashboardData: any = async (req: any) => {
	const response = await axios.post(GET_DASHBOARD_DATA, req);
	return response.data;
};

const saveDashboardFile: any = async (req: any) => {
	const response = await axios.post(SAVE_DASHBOARD_FILE, req);
	return response.data;
};

const getDashboardHistory: any = async (req: any) => {
	const response = await axios.post(GET_HISTORY_DASHBOARD, req);
	return response.data;
};

const getContractorsRoyalties: any = async (req: any) => {
	const response = await axios.post(GET_CONTRACTOR_ROYALTIES, req);
	return response.data;
};

const updateContractorRoyalties: any = async (req: any) => {
	const response = await axios.post(UPDATE_CONTRACTOR_ROYALTIES, req);
	return response.data;
};

const getDmsList = async (req: { tenant?: string }) => {
	const response = await axios.get(GET_DMS_LIST, {
		params: {
			tenant: req.tenant,
		},
	});
	return response.data;
};

const saveAssociations: any = async (req: any) => {
	const response = await axios.post(SAVE_CONTRACTOR_ASSOCIATIONS, req);
	return response.data;
};

const getContractorById: any = async (req: { id: number }) => {
	const response = await axios.get(GET_CONTRACTOR_BY_ID + req.id);
	return response.data;
};

export {
	searchContractor,
	insertDocumentsContractor,
	updateDashboard,
	getDashboardData,
	saveDashboardFile,
	getDashboardHistory,
	getContractorsRoyalties,
	updateContractorRoyalties,
	getDmsList,
	saveAssociations,
	getContractorById,
};
